import type { SyncJobsReport } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getSyncJobs = async (): Promise<SyncJobsReport> => {
  const response = await apiClient.get<SyncJobsReport>('/directory/sync/jobs');
  return response.data;
};
